import React from "react";

interface State {
  error: Error | null;
}

/**
 * Captura erros de lazy-load de chunks (falhas de rede ou MIME type errado).
 * Sem isso, um chunk que falha ao carregar mata toda a árvore React,
 * deixando a tela completamente em branco.
 */
export class ChunkErrorBoundary extends React.Component<
  { children: React.ReactNode },
  State
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      const isChunkError =
        this.state.error.message.includes("Failed to fetch dynamically imported module") ||
        this.state.error.message.includes("Failed to load module script") ||
        this.state.error.message.includes("Importing a module script failed");

      return (
        <div className="min-h-screen flex items-center justify-center bg-white p-8">
          <div className="max-w-md text-center space-y-4">
            <div className="text-4xl font-bold text-black">Acervo</div>
            <p className="text-black/60 text-sm">
              {isChunkError
                ? "Houve uma atualização do sistema. Recarregue para continuar."
                : "Ocorreu um erro inesperado."}
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              className="px-6 py-2 bg-black text-white text-sm font-semibold hover:opacity-80 transition-opacity"
            >
              Recarregar
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
